module.exports = __webpack_public_path__ + "static/favicon-d759163181d2dfdfb3ec43270226a43b.png";